import React from "react";
import Fontstyling from "../../components/common/comman";
import { useEffect } from "react";
import { useState } from "react";

const Signout = ({ navigate }) => {
  return (
    <div className="container align-items-center d-flex justify-content-center vh-100">
      <div className="row">
        <div className="card p-5 m-5 text-center border-0">
          <div className="card-body">
            <h2 className="card-title fs-5 font-monospace fw-bold">
              Logged Out
            </h2>
            <p className="card-text mt-2" style={Fontstyling.primaryparagraph}>
              Thank you for using Fusion
            </p>
            <p className="card-text mt-2" style={Fontstyling.primaryparagraph}>
             Please reload the page to use Fusion again
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signout;
